import URI from 'urijs'
import { alertFailedEnterRoom } from './dialog'
import { storeJoin } from './dexie'
import { rxJoin, rxLeave, rxSound, rxChat } from './rx_subject'
import store from '../redux/store'
import { setWebSocket } from '../redux/actions/browser'
import { reset, recvSelfID, recvRoom } from '../redux/actions/main'
import { recvRooms } from '../redux/actions/rooms'
import { recvChat } from '../redux/actions/chat'
import { recvRule } from '../redux/actions/rule'
import { recvButton } from '../redux/actions/button'
import { recvSg } from '../redux/actions/score'
import { recvBg, recvBoard } from '../redux/actions/board'
import { recvTimer } from '../redux/actions/timer'

const uri = URI(window.location.href).protocol('ws').pathname('/ws')

const recv = {
  rooms: rooms => store.dispatch(recvRooms(rooms)),
  chat: chat => store.dispatch(recvChat(chat)),
  rule: rule => store.dispatch(recvRule(rule)),
  button: button => store.dispatch(recvButton(button)),
  sg: sg => store.dispatch(recvSg(sg)),
  bg: bg => store.dispatch(recvBg(bg)),
  board: board => store.dispatch(recvBoard(board)),
  timer: timer => store.dispatch(recvTimer(timer)),
  selfID: selfID => store.dispatch(recvSelfID(selfID)),
  room: room => store.dispatch(recvRoom(room))
}

export const createWebSocket = () => {
  const ws = new WebSocket(uri.toString())

  ws.onopen = evt => {
    store.dispatch(setWebSocket(ws))
    console.log('ws open', evt)
  }

  ws.onclose = evt => {
    console.log('ws close', evt)
    store.dispatch(setWebSocket(null))
    store.dispatch(reset())
    createWebSocket()
  }

  ws.onmessage = evt => {
    const data = JSON.parse(evt.data)
    switch (data.type) {
      case 'joined':
        rxJoin.next(data.content)
        break
      case 'left':
        rxLeave.next(data.content)
        break
      case 'failedJoin':
        alertFailedEnterRoom()
        break
      case 'join':
        storeJoin(data.content)
        break
      case 'sound':
        rxSound.next(data.content)
        break
      case 'chat':
        rxChat.next(data.content)
        recv.chat(data.content)
        break
      default:
        recv[data.type](data.content)
    }
  }

  ws.onerror = evt => {
    console.log('ws error: ' + evt.data)
  }
}
